import { useMemo } from 'react';

import { findStaticDataFetcherItemByValue, StaticDataFetcherItem, useStaticDataProvider } from '@hh.ru/magritte-ui';
import { Select } from '@hh.ru/magritte-ui-select';
import { TranslatedComponent } from 'bloko/common/hooks/useTranslations';

import translation from 'src/components/translation';
import { NARROW_NON_BREAKING_SPACE } from 'src/utils/constants/symbols';

const TrlKeys = {
    resumes: 'employer.resumesSearch.resumes',
};

interface ItemsOnPageProps {
    onChange: (value: number) => void;
    value: number;
}

const DEFAULT_SORT_VALUES = [20, 50, 70, 100];

const ItemsOnPage: TranslatedComponent<ItemsOnPageProps> = ({ onChange, value, trls }) => {
    const sortValues = useMemo(() => {
        const updatedSortValues = [...DEFAULT_SORT_VALUES];

        if (!updatedSortValues.includes(value)) {
            updatedSortValues.push(value);
            updatedSortValues.sort((a, b) => Number(a) - Number(b));
        }

        return updatedSortValues;
    }, [value]);

    const items: StaticDataFetcherItem[] = useMemo(
        () =>
            sortValues.map((sortCounter) => ({
                text: `${sortCounter}${NARROW_NON_BREAKING_SPACE}${trls[TrlKeys.resumes]}`,
                value: String(sortCounter),
            })),
        [sortValues, trls]
    );

    const provider = useStaticDataProvider(items);

    return (
        <Select
            type="radio"
            name="items_on_page"
            value={findStaticDataFetcherItemByValue(String(value), items)}
            dataProvider={provider}
            widthEqualToActivator={false}
            bottomSheetHeight="content"
            plain
            renderHeader={() => undefined}
            triggerProps={{
                size: 'xsmall',
                'data-qa': 'resume_search_items_on_page',
            }}
            onChange={(item) => {
                onChange(Number(item.value));
            }}
        />
    );
};

export default translation(ItemsOnPage);
